import { Freeform } from 'components/common/Freeform';

const ErrorMessage = ({ message, index }) => {
  let blocks = null;
  try {
    blocks = message.content ? JSON.parse(message.content)?.blocks : null;
  } catch {}

  return (
    <div
      id={`error-message-${index}`}
      key={index}
      className="flex justify-start flex-wrap flex-col my-4"
    >
      <div className="flex flex-row bg-white text-gray-900 rounded-md p-4">
        <div
          className="p-4 color-gray-900"
          style={{
            '& a': {
              textDecoration: 'underline',
            },
          }}
        >
          {blocks && <Freeform blocks={blocks}></Freeform>}
          {!blocks && <div>{message.content}</div>}
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;
